import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, LucideIcon } from 'lucide-react';

interface CategoryCardProps {
    /** Where the card leads; a card without one is plain content (the text fields in Allmänt). */
    to?: string;
    Icon: LucideIcon;
    label: string;
    /** One muted line about the page, under the label. */
    description?: string;
    children?: React.ReactNode;
}

/**
 * One card in a category tab: an icon badge next to the label and its
 * one-line description, then any free content. Link cards get a chevron and
 * lift on hover.
 */
const CategoryCard: React.FC<CategoryCardProps> = ({ to, Icon, label, description, children }) => {
    const content = (
        <>
            <span className="bp-card-head">
                <span className="bp-card-badge"><Icon size={18} aria-hidden="true" /></span>
                <span className="bp-card-title">
                    <span className="bp-card-label">{label}</span>
                    {description && <span className="bp-card-description">{description}</span>}
                </span>
                {to && <ChevronRight className="bp-card-chevron" size={18} aria-hidden="true" />}
            </span>
            {children}
        </>
    );
    return to
        ? <Link to={to} className="bp-card bp-card--link">{content}</Link>
        : <section className="bp-card">{content}</section>;
};

export default CategoryCard;
